<div class="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-80 lg:flex-col pt-3">
  <div class="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
    <div class="flex h-auto shrink-0 items-center justify-center">
      <!-- Los dos logos llevan al inicio: el horizontal es el control de teclado y el cuadrado, un atajo de ratón. -->
      @if (!soloLogoBase) {
        <img class="c-pointer w-[22%] mr-3" [src]="logoCuadrado" alt="Logo cuadrado" aria-hidden="true"
          (click)="volverAlHome()">
      }
      <img class="c-pointer" [src]="logoBase" alt="Logo horizontal"
        role="link" tabindex="0" aria-label="Volver al inicio"
        [ngClass]="{'w-[63%]': !soloLogoBase, 'w-[72%]': soloLogoBase}"
        (click)="volverAlHome()"
        (keydown.enter)="$event.preventDefault(); volverAlHome()">
    </div>
    <nav class="flex flex-1 flex-col">
      <ul role="list" class="flex flex-1 flex-col gap-y-7">
        <li>
          <app-conversaciones #conversacionWeb></app-conversaciones>
        </li>
      </ul>
    </nav>
  </div>
</div>

<div class="hidden fixed inset-0 bg-gray-900/80 z-10" id="overlay"></div>

<div class="transition hidden fixed inset-0 flex ease-in-out delay-150 z-10 mt-16" id="conversaciones">
  <div class="relative mr-16 flex w-full max-w-xs flex-1">
    <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
      <button type="button" class="-m-2.5 p-2.5" (click)="toogleConversaciones()">
        <span class="sr-only">Close sidebar</span>
        <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
      <nav class="flex flex-1 flex-col mt-5">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
          <li>
            <app-conversaciones (chatSeleccionado)="toogleConversaciones()"
              [esDispositivoMovil]="true"
              [carpetas]="conversacionWeb.carpetas ? conversacionWeb.carpetas : []"
              [conversaciones]="conversacionWeb.conversaciones ? conversacionWeb.conversaciones : []">
            </app-conversaciones>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
<div class="lg:pl-80 h-full w-full">
  <div class="top-0 sticky z-10  border-b border-gray-200 ">
    <div
      class="flex h-16 items-center gap-x-4 bg-white px-4 shadow-none sm:gap-x-6 lg:shadow-none">
      @if (!soloLogoBase) {
        <img class="h-8 w-auto c-pointer lg:hidden" [src]="logoCuadrado" alt="Logo cuadrado"
          role="link" tabindex="0" aria-label="Volver al inicio"
          (click)="volverAlHome()"
          (keydown.enter)="$event.preventDefault(); volverAlHome()">
      }
      <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" (click)="toogleConversaciones()">
        <span class="sr-only">Open sidebar</span>
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
        </svg>
      </button>

      <!-- Separator -->
      <div class="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true"></div>
      <div class="flex flex-1 self-stretch lg:gap-x-6 justify-between w-full">
        <app-menu (opcionMenuActiva)="gestionarPanelMenu($event)"
          class="lg:flex flex items-center gap-x-4 w-full"
        ></app-menu>
        <div class="flex items-center gap-x-4 lg:gap-x-6">

          <div class="relative inline-block">
            @if (mostrarTooltip && rutaActualTieneAyuda()) {
              <div class="fixed inset-0 bg-gray-500/75 transition-opacity"
              ></div>
            }
            @if (mostrarTooltip && rutaActualTieneAyuda()) {
              <div class="flex flex-col">
                <div
                  class="mt-5 px-4 py-4 text-sm absolute top-full left-1/2 transform -translate-x-1/2 w-120 bg-white text-gray-800 border border-gray-300 rounded-lg shadow-lg tooltip-container z-20">
                  <app-tooltip [text]="'Accede a las guías de uso según la pantalla en la que te encuentras.'"
                    [title]="'Acceso manual de uso'"
                    [mostrarBoton]="true"
                  (dismissed)="marcarTooltip($event)"></app-tooltip>
                </div>
              </div>
            }
            <!-- Siempre en su sitio para que la cabecera no salte al navegar; sin guía queda deshabilitado. -->
            <button id="abrir-ayuda" type="button"
              [ngClass]="mostrarTooltip ? 'z-10' : 'z-0'"
              [disabled]="!rutaActualTieneAyuda()"
              [attr.title]="(rutaActualTieneAyuda() ? 'Guía de uso de esta pantalla' : 'Esta pantalla no tiene guía de uso') | translate"
              class="text-indigo-600 text-lg bg-white focus:outline-hidden hover:bg-indigo-100 inline-flex items-center justify-center w-10 h-10 rounded-full p-3 leading-6 font-semibold c-pointer border shadow-xs hover:border-indigo-500 relative disabled:cursor-not-allowed disabled:text-gray-300 disabled:shadow-none disabled:hover:bg-white disabled:hover:border-gray-200"
              (click)="abrirAyuda()">?
            </button>
          </div>
          <div class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" aria-hidden="true"></div>
          <div class="relative">
            <button type="button" class="-m-1.5 flex items-center p-1.5" id="user-menu-button" aria-expanded="false"
              aria-haspopup="true" (click)="toogleOpcionesPerfil()">
              <span class="sr-only">Open user menu</span>
              @if (imagenPerfil) {
                <img class="h-8 w-8 rounded-full bg-gray-50" src="{{imagenPerfil}}" alt="">
              }
              @if (!imagenPerfil) {
                <span class="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
                  <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                  </svg>
                </span>
              }

              <span class="hidden lg:flex lg:items-center">
                <div class="flex items-center">
                  @if (permisoSalesForce && authProvider === 'salesforce') {
                    <span class="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
                      {{ permisoSalesForce.email }}
                    </span><br>
                  }
                  @if (usuarioMSAL && authProvider === 'msal') {
                    <span class="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
                      {{ usuarioMSAL!.name }}
                    </span>
                  }
                </div>
                <svg class="ml-2 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd"/>
                </svg>
              </span>
            </button>
            <div
              class="hidden absolute right-0 z-20 mt-3 w-56 origin-top-right rounded-lg bg-white p-1 shadow-lg ring-1 ring-gray-900/5 focus:outline-hidden"
              role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1"
              id="opciones-perfil">
              <a class="group flex items-center gap-x-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 c-pointer hover:bg-gray-50 hover:text-gray-900"
                role="menuitem" tabindex="-1" id="user-menu-item-memoria" routerLink="/memoria"
                (click)="toogleOpcionesPerfil()">
                <span aria-hidden="true" class="memoria-icono size-5 shrink-0 text-gray-400 group-hover:text-gray-500"></span>
                {{ 'Memoria' | translate }}
              </a>
              <div class="-mx-1 my-1 border-t border-gray-100" role="separator"></div>
              @if (authProvider === 'salesforce') {
                <app-boton-cerrar-sesion-salesforce></app-boton-cerrar-sesion-salesforce>
                }  @else {
                <a class="group flex items-center gap-x-3 rounded-md px-3 py-2 text-sm font-medium text-gray-700 c-pointer hover:bg-gray-50 hover:text-gray-900"
                  role="menuitem" tabindex="-1" id="user-menu-item-1" (click)="logout()" (keydown.enter)="$event.preventDefault(); logout()">
                  <svg aria-hidden="true" class="size-5 shrink-0 text-gray-400 group-hover:text-gray-500" fill="none" stroke="currentColor"
                    stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"/>
                  </svg>
                  {{ 'Cerrar sesión' | translate }}
                </a>
              }

            </div>
          </div>
        </div>
        <app-panel-menu class="absolute rounded-b-md sh left-0 top-full w-full bg-white shadow-xl z-9999"
          (elementoHijoSeleccionado)="cerrarPanelYMarcarElementoPadreComoActivo()">
        </app-panel-menu>
      </div>
    </div>
  </div>
  <main class="lg:mt-7 mt-2" [class.citation-panel-open]="panelLateralService.isCitationOpen$ | async">
    <div class="mx-auto max-w-full px-4 sm:px-6 lg:px-8 w-full h-full ">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
